import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Home", path: "/" },
    { label: "Services", path: "/services" },
    { label: "Industries", path: "/industries" },
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-[#09090B]/95 backdrop-blur-md border-b border-white/5 py-3" : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/737439b21121152bcfa7b4fdd551ee4d.png"
            alt="GroundsWell AI Logo"
            className="h-[90px] w-[90px] object-contain"
          />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${
                location.pathname === link.path
                  ? "text-[#4ADE80]"
                  : "text-white/70 hover:text-white"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="#get-started"
            className="whitespace-nowrap px-5 py-2 rounded-md bg-[#4ADE80] text-[#09090B] text-sm font-semibold hover:bg-[#22C55E] transition-colors duration-200 cursor-pointer"
          >
            Build My Foundation
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${menuOpen ? "close" : "menu"}-line text-xl`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#09090B]/98 border-t border-white/5 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMenuOpen(false)}
              className={`text-sm font-medium transition-colors cursor-pointer ${
                location.pathname === link.path ? "text-[#4ADE80]" : "text-white/70"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <a
            href="#get-started"
            onClick={() => setMenuOpen(false)}
            className="whitespace-nowrap px-5 py-2 rounded-md bg-[#4ADE80] text-[#09090B] text-sm font-semibold text-center cursor-pointer"
          >
            Build My Foundation
          </a>
        </div>
      )}
    </header>
  );
}
